import { MessageCircle } from 'lucide-react';
import { useLocale } from '@/contexts/LocaleContext';
import { useLocation } from 'react-router-dom';

const WHATSAPP_NUMBER = '96550771733';
const DEFAULT_MESSAGE_AR = 'ياهلا باليت.. عندي استفسار بخصوص الورش والفعاليات';
const DEFAULT_MESSAGE_EN = 'Hi Palette! I have a question about your workshops and activities.';

export default function FloatingWhatsApp() {
  const { locale, direction } = useLocale();
  const { pathname } = useLocation();

  // Hide on admin/exec/instructor backend routes to avoid overlap with sub-navs
  if (/^\/(admin|ceo|cfo|coo|instructor)(\/|$)/.test(pathname)) return null;

  const message = locale === 'ar' ? DEFAULT_MESSAGE_AR : DEFAULT_MESSAGE_EN;
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  const isRtl = direction === 'rtl';

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={locale === 'ar' ? 'تواصل عبر واتساب' : 'Chat on WhatsApp'}
      className={[
        'fixed bottom-5 z-30 flex items-center gap-2',
        'h-14 w-14 sm:h-auto sm:w-auto sm:px-4 sm:py-3',
        'rounded-full bg-[#25D366] text-white shadow-elevated',
        'hover:scale-105 active:scale-95 transition-transform',
        'justify-center',
        isRtl ? 'left-4' : 'right-4',
      ].join(' ')}
      style={{
        boxShadow: '0 10px 30px -8px rgba(37, 211, 102, 0.55), 0 4px 12px rgba(0,0,0,0.15)',
      }}
    >
      <MessageCircle className="w-7 h-7 sm:w-5 sm:h-5" />
      <span className="hidden sm:inline font-bold text-sm whitespace-nowrap">
        {locale === 'ar' ? 'واتساب باليت' : 'WhatsApp Palette'}
      </span>
      <span className="absolute -top-1 -right-1 sm:hidden flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-[#25D366] border-2 border-white" />
      </span>
    </a>
  );
}
